import * as React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

// Utils
import { selectors } from '@src/shared/src';
// Components
import { Co2EmissionLabel } from '@src/components/Co2EmissionLabel';

type Props = {
  showTransportCo2Total: boolean;
  showHotelCo2Total: boolean;
  showRentalCo2Total: boolean;
};

const CheckoutSideBarCo2Info: React.FC<Props> = ({
  showTransportCo2Total,
  showHotelCo2Total,
  showRentalCo2Total,
}) => {
  const { t } = useTranslation();
  const transportCo2Total = useSelector(selectors.checkout.basketTransportCo2Total);
  const hotelCo2Total = useSelector(selectors.checkout.basketHotelCo2Total);
  const rentalCo2Total = useSelector(selectors.checkout.basketRentalCo2Total);
  const bookingCo2Total = useSelector(selectors.checkout.basketCo2Total);

  return (
    <div className="sidebar-inner">
      <div className="sidebar-title">{t('CheckoutSideBarConn.co2_emissions.label')}</div>
      {showTransportCo2Total && (
        <div className="sidebar-route sidebar-route-expanded">
          <div className="sidebar-route-title">{t('CheckoutSideBarConn.transport.label')}</div>
          <Co2EmissionLabel value={transportCo2Total} withIcon={false} />
        </div>
      )}

      {showHotelCo2Total && (
        <div className="sidebar-route sidebar-route-expanded">
          <div className="sidebar-route-title">{t('CheckoutSideBarConn.hotel.label')}</div>
          <Co2EmissionLabel value={hotelCo2Total} withIcon={false} />
        </div>
      )}

      {showRentalCo2Total && (
        <div className="sidebar-route sidebar-route-expanded">
          <div className="sidebar-route-title">{t('CheckoutSideBarConn.rental.label')}</div>
          <Co2EmissionLabel value={rentalCo2Total} withIcon={false} />
        </div>
      )}

      <div className="sidebar-route sidebar-route-expanded">
        <strong className="sidebar-route-title">{t('CheckoutSideBarConn.total.label')}</strong>
        <Co2EmissionLabel value={bookingCo2Total} large />
      </div>
    </div>
  );
};

export default CheckoutSideBarCo2Info;
